import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pntx8vkece: FaireBrandEntity = {
  token: "b_pntx8vkece",
  type: "brand",
  name: "Awaken",
  avatarUrl:
    "https://cdn.faire.com/fastly/6f243986eef82a731b056c6fd6f0938c5b5daa1a59d1b60722ce6d6482f10d7d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/12ca65fed50e302d8ac52ca22f6124b60c2a49639d4b68d05fbdbba59cebbb42.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6f243986eef82a731b056c6fd6f0938c5b5daa1a59d1b60722ce6d6482f10d7d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/12ca65fed50e302d8ac52ca22f6124b60c2a49639d4b68d05fbdbba59cebbb42.jpeg",
  location: "Milano, ITA",
  minimumOrderDollars: 130,
  rating: 4.8,
  reviewCount: 38,
  isTopShop: true,
  isInsider: false,
  description:
    "Our story was born in a small shop in the heart of the city of Milan in 2008. The Awaken Piercing brand was born with the aim of bringing safe, high quality and varied piercings to the public such as to allow them to express themselves. \n\n\n\nAfter 8 years of experience in the sector, we decided to start our e-business to bring our products to a much wider audience around the world. \n\n\n\n\nOur products are made with studied and safe material, are tested in accredited Italian laboratories, and comply with REACH standards. You can download the certifications directly from our site or request a copy from our customer service [redacted-email].\n\n\n\nOur team is young, inclusive and professional, made up of people from various parts of the world and specialized in different fields. We are happy to receive your questions via email [redacted-email] or WhatsApp +39 [redacted-phone].\n\n\n\nOur 2000 square meter logistics center is located in Italy, we have collaborations with several couriers allowing us to process your orders within 24 hours and reach anywhere in the world. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:45.571Z",
    importedBy: "entity-db-cli",
  },
};
